import { useEffect, useState } from "react";
import { getSession, onAuthChange } from "./auth.js";

export function useSession() {
  const [session, setSession] = useState(undefined); // undefined = loading
  useEffect(() => {
    let alive = true;
    getSession().then(s => { if (alive) setSession(s); });
    const off = onAuthChange((s) => { if (alive) setSession(s); });
    return () => { alive = false; off?.(); };
  }, []);
  return session;
}
